import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDiamond = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.976 8h24.048a1.69 1.69 0 0 1 1.365.695l6.45 8.868a.844.844 0 0 1-.063 1.068L24.62 39.383a.843.843 0 0 1-1.19.047c-.013-.01-6.412-6.942-19.205-20.8a.84.84 0 0 1-.063-1.068l6.45-8.868A1.69 1.69 0 0 1 11.976 8m.86 3.374L8.112 17.87 24 35.078 39.888 17.87l-4.724-6.496z" })
});
export default SvgDiamond;
